module.exports = __webpack_public_path__ + "static/media/hydropurr-1.6f529923.jpg";